import sal from "sal.js"
import "media-chrome"
import "vimeo-video-element"
import { projectCards } from "./components/projectCards.js"
import { serviceListing } from "./components/servicesList.js"

gsap.registerPlugin(ScrollTrigger)

addEventListener("beforeunload", (event) => {
    if(!document.activeElement.href){
        window.scrollTo(0, 0);
    }
})

window.addEventListener("DOMContentLoaded", (event) => {
    sal()
    // gsap.registerPlugin(Draggable)

    // get browser size - these are global vars!
    window.windowWidth = window.innerWidth
    window.windowHeight = window.innerHeight
    window.scrolledY = window.scrollY
    // re-get var on resize
    window.addEventListener("resize", (event) => {
        windowWidth = window.innerWidth
        windowHeight = window.innerHeight
    })

    //rewrote function to depreciate jQuery - CC
    // handles dropdown clicking
    var clickHandler = function () {
        document.querySelectorAll("#dropbtn").innerHTML = event.target.innerHTML
    }
    let dropdown = document.querySelectorAll("#dropdown")
    dropdown.forEach((el) => {
        let filterItem = el.querySelectorAll("#dropdown li")
        for (let i = 0; i < filterItem.length; i++) {
            let current = filterItem[i]
            current.addEventListener("click", clickHandler, false)
        }
    })

    // counter ticker for projects / can be used globally.
    // ensure counter id is different
    // structure:
    // div.counter-wrapper#counter-1
    // | - div.stat
    //   | - p.number
    //     | - span.number

    let counters = document.querySelectorAll(".counter-wrapper")
    if (counters) {
        counters.forEach((el) => {
            let counterID = el.id
            // console.log(counterID)
            const counterTL = gsap.timeline({
                scrollTrigger: {
                    trigger: "#" + counterID,
                    start: "top bottom",
                    end: "bottom bottom",
                    scrub: 1,
                },
            })
            counterTL.from("#" + counterID + " .stat .number span", {
                textContent: 0,
                duration: 2,
                ease: "Power2.easeOut",
                snap: { textContent: 1 },
                stagger: {
                    each: 0.25,
                    onUpdate: function () {
                        this.targets()[0].innerHTML = numberWithCommas(
                            Math.ceil(this.targets()[0].textContent)
                        )
                    },
                },
            })
        })
    }

    const bubbles = document.querySelectorAll(".desktop-bubble");
    const mobileBubbles = document.querySelectorAll(".mobile-bubble");

    if(bubbles){
        let delay = 0.4;
        bubbles.forEach((bubble) => {
            delay = delay + 0.4;
            gsap.to("#" + bubble.id, {
                scrollTrigger: '#bubblesDesktop',
                duration: 0.2,
                opacity: 1,
                delay: delay,
                ease: "power1.inOut"
            })
            gsap.to("#" + bubble.id, {
                scrollTrigger: "#bubblesDesktop",
                duration: 0.4,
                scale: 1.1,
                delay: delay,
                ease: "power1.inOut",
                repeat: 1,
                yoyo: true,
                transformOrigin: "center",
            });
        })
    }

    if(mobileBubbles){
        let delay = 0.4;
        mobileBubbles.forEach((bubble) => {
            gsap.to("#" + bubble.id, {
                scrollTrigger: '#' + bubble.id,
                duration: 0.2,
                opacity: 1,
                delay: 0.4,
                ease: "power1.inOut"
            })
            gsap.to("#" + bubble.id, {
                scrollTrigger: "#" + bubble.id,
                duration: 0.4,
                scale: 1.1,
                delay: 0.4,
                ease: "power1.inOut",
                repeat: 1,
                yoyo: true,
                transformOrigin: "center",
            });
        })
    }

    // project cards
    projectCards(windowWidth, windowHeight)

    // service listings
    serviceListing()
})
